import gql from 'graphql-tag';

export const TEAMS_RESILIENCE_ANCHORS = gql`
  query reportingTeamsResilienceAnchors($includingManager: Boolean) {
    reportingTeamsResilienceAnchors(includingManager: $includingManager)
  }
`;
